const { cELM, getWindowHeight, getAnswerVariableCssClass } = require("../utils");
const Scroller = require("../components/scroller");
const Provider = require("../components/blocks/provider.js");
const Block = require("../components/blocks/index");
const ProgressBar = require("../components/progress-bar");
const Notification = require("../components/notification");
const ScrollNotification = require("../components/scroll-notification");
//Include this file in bot.js and follow examples for other modules. The questions will be rendered in the server side -Rich

class PreviousBalanceModule {
  constructor(type, value, parentRef) {
    this.type = type;
    this.value = value;
    this.parent = parentRef;
    const cssVariableKey = getAnswerVariableCssClass(value);
    this.elContainer = cELM("div", `previousbalance-module ${cssVariableKey}`);
    this.contentHash = {};
    this.typingIndicator = null;
  }

  handle(type, value, reference) {
    if (this.typingIndicator) {
      this.elContainer.removeELM(this.typingIndicator);
      this.typingIndicator = null;
    }

    // update progress bar
    if (value.progress) {
      ProgressBar.updateProgress(value.progress);
    }

    const _elm = this.handleOnMessage(value);
    if (!_elm) return;
    this.elContainer.addELM(_elm);

    // add show more button
    this.showMore(_elm.getELM());

    if (value.status !== "typing") {
      Scroller.scrollToElm(_elm, () => {
        _elm.focus();
      });
    }
  }

  handleTypingOnClick(component) {
    if(!component) {
      return;
    }
    //handle click
    let buttons;
    const elToAttach = component._option._element.getELM();

    if(component._data && component._data.format === 'creditcard') {
      buttons = elToAttach.getElementsByClassName('continue-button');
    }
    else if(component._option && component._option._element && component._option._element.getELM) {
      buttons = elToAttach.getElementsByClassName('option');
    }

    if(!buttons) {
      return;
    }

    const addTyping = () => {
      this.parent && this.parent.showTyping && this.parent.showTyping();
    };

    for (const button of buttons) {
      button.addEventListener("click", addTyping, false);
    }
  }

  handleOnMessage(value) {
    const questionOrCCInput = value.values;
    let component = null;

    if (value.format === "empty") return null;

    let identifier = value.values.id;

    if ((((value || {}).values || {}).format || '').indexOf("info-card-v2") > -1) {
      this.clearAfterId(identifier);
    }

    if (identifier.indexOf("/answer") > -1) {
      const idParts = identifier.split("/answer/");
      identifier = idParts[0] + "/" + idParts[1];

      if(identifier && this.contentHash[identifier]){
        const question = this.contentHash[identifier][1];
        question.updateAnswer(value.values, this.clearAfterId.bind(this));

        if(question && question._data && question._data.id && 
            (question._data.id.endsWith('previousbalance/7') || question._data.id.endsWith('previousbalance/10'))) {
          //C.A. when user press "next" in the last question, exists a little delay that the chatbot looks like "frozen",
          //we need to show "TYPING" until the next question/component comes to the UI
          this.parent && this.parent.showTyping && this.parent.showTyping();
        }        
      }

    } else if (!this.contentHash[identifier]) {
      const ccParams = { data: {} };

      if (questionOrCCInput.name && questionOrCCInput.number && questionOrCCInput.cvc) {
        for (let p in questionOrCCInput) {
          ccParams.data[p] = questionOrCCInput[p];
        }

        ccParams.data.text = questionOrCCInput.text;
        ccParams.data.subtext = questionOrCCInput.subtext;
        ccParams.data.format = "creditcard";
        ccParams.data.values = questionOrCCInput.values;

        component = new Block(ccParams);
      } else {
        ccParams.data = questionOrCCInput;
        component = new Block(ccParams);
      }

      if (value.status === "typing" || value.id.indexOf("/") === -1) {
        this.typingIndicator = component;
      } else {
        this.contentHash[identifier] = [Object.keys(this.contentHash).length, component];

        if (value.values && value.values.error && component._option._element.handleOnError) {
          component._option._element.handleOnError(value.values.error, false);
        }
      }
    } else {
      component = this.contentHash[identifier][1];
      if (value.values && value.values.error && component._option._element.handleOnError) {
        component._option._element.handleOnError(value.values.error, value.values.transactionId);
      }
      if ((value.values || {}).format == "email" && (value.values || {}).isError == true) {
        this.clearAfterId(identifier);
        component = new Block({ data: value.values });
        this.contentHash[identifier] = [Object.keys(this.contentHash).length, component];
      }
    }

    this.handleTypingOnClick(component);

    return component;
  }

  getHTML() {
    return this.elContainer;
  }

  getELM() {
    return this.elContainer;
  }

  clearAfterId(id) {
    const index = (this.contentHash[id] || [])[0];
    const newHash = {};

    Object.keys(this.contentHash).forEach(key => {
      const ch = this.contentHash[key];
      if (ch[0] >= index 
        // GO: we need to clean the next editable questions to avoid unexpected behaviors
          || ((ch[1] || {})._data || {}).format == "creditcard"
          || (((ch[1] || {})._data || {}).id || '').endsWith("previousbalance/3")
          || (((ch[1] || {})._data || {}).id || '').endsWith("previousbalance/4")
          || (((ch[1] || {})._data || {}).id || '').endsWith("previousbalance/5")
          || (((ch[1] || {})._data || {}).id || '').endsWith("previousbalance/6")
          ) {
        this.elContainer.removeELM(ch[1]);
      } else {
        newHash[key] = ch;
      }
    });

    this.contentHash = newHash;
  }

  showMore(elm) {
    const height = getWindowHeight();
    const bound = elm.getBoundingClientRect();

    if (bound.height > height) {
      ScrollNotification.attachElement(elm);
    }
  }
}

module.exports = PreviousBalanceModule;
